import React from 'react';
import { NavLink, Outlet, Navigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Logo from '../../components/Logo';

const AdminLayout = () => {
  const { user, checking, logout } = useAuth();
  if (checking) {
    return <div className="min-h-screen flex items-center justify-center bg-cream font-sans text-navy/60 text-sm tracking-[0.3em]">LOADING…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;

  const linkCls = ({ isActive }) =>
    `font-sans text-[11px] tracking-[0.3em] px-4 py-2 rounded-full transition-colors ${
      isActive ? 'bg-navy text-cream' : 'text-navy hover:bg-navy/10'
    }`;

  return (
    <div className="min-h-screen bg-cream" data-testid="admin-layout">
      <header className="border-b border-navy/10 bg-cream/95 backdrop-blur-sm sticky top-0 z-30">
        <div className="max-w-[1440px] mx-auto px-8 py-4 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-3" data-testid="admin-home-link">
            <Logo size="small" />
            <span className="font-sans text-[10px] tracking-[0.3em] text-navy/60">ADMIN</span>
          </Link>
          <nav className="flex flex-wrap items-center gap-1">
            <NavLink to="/admin" end className={linkCls} data-testid="admin-nav-dashboard">DASHBOARD</NavLink>
            <NavLink to="/admin/content/site" className={linkCls} data-testid="admin-nav-site">SITE-WIDE</NavLink>
            <NavLink to="/admin/content/home" className={linkCls} data-testid="admin-nav-home">HOME</NavLink>
            <NavLink to="/admin/content/team" className={linkCls} data-testid="admin-nav-team-content">TEAM PAGE</NavLink>
            <NavLink to="/admin/content/advisory" className={linkCls} data-testid="admin-nav-advisory">ADVISORY</NavLink>
            <NavLink to="/admin/content/investment" className={linkCls} data-testid="admin-nav-investment">INVESTMENT</NavLink>
            <NavLink to="/admin/content/contact" className={linkCls} data-testid="admin-nav-contact">CONTACT</NavLink>
            <NavLink to="/admin/team" className={linkCls} data-testid="admin-nav-team-members">TEAM MEMBERS</NavLink>
          </nav>
          <div className="flex items-center gap-3">
            <Link to="/" target="_blank" className="font-sans text-[10px] tracking-[0.3em] text-navy/60 hover:text-navy">VIEW SITE ↗</Link>
            <button onClick={logout} data-testid="admin-logout"
              className="font-sans text-[10px] tracking-[0.3em] text-navy/60 hover:text-red-700">LOG OUT</button>
          </div>
        </div>
      </header>
      <main className="max-w-[1440px] mx-auto px-8 py-10"><Outlet /></main>
    </div>
  );
};

export default AdminLayout;
